import { useEffect, useState } from "react"
import { CatchWrapperAsync } from "../utils/catchwrapper"
import AxiosFetchData from "../pages/AxiosFetchData"
import { useNavigate } from "react-router-dom"
import Box from '@mui/material/Box';
const Projectdetail = ({id,message,tipe,roleaccess = null}) => {
    const navigate = useNavigate()
    const [projectName,setProjectName] = useState('')
    const [customerName, setCustomerName] = useState('')

    useEffect(() =>{
        fetch()
    },[])

    const fetch = () =>{
        CatchWrapperAsync(async() => {
            const response = await AxiosFetchData.get(`GetProjects`).refreshToken(navigate,"requestmaterial")
           // console.log(response)
            if(roleaccess!=null){
                roleaccess(response.roleaccess)
            }
            const project = response.data.data.filter((item) => item.project_id == id)[0]
            setProjectName(project.project_name)
            setCustomerName(project.customer_name)
        },message,tipe)
    }

    return (
         <Box sx={{ p: 2,m:0,boxShadow:3, border: '1px solid grey',backgroundColor :"#f6f6f6", marginBottom:3,fontSize:12}}>
                <div >
            <div className="form-group row">
                <label for="staticEmail" class="col-sm-2">Project Name :</label>
                <label for="staticEmail" class="col-sm-6">{projectName}</label>
            </div>
            <div className="form-group row">
                <label for="staticEmail" class="col-sm-2">Customer Name :</label>
                <label for="staticEmail" class="col-sm-6">{customerName}</label>
            </div>
        </div>
         </Box>
        
         
    )
}

export default Projectdetail